import { render, staticRenderFns } from "./PublicRelatedArticleCardList.vue?vue&type=template&id=0c7b4ac5&lang=pug&"
import script from "./PublicRelatedArticleCardList.vue?vue&type=script&lang=js&"
export * from "./PublicRelatedArticleCardList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports